import * as swcHelpers from '@swc/helpers';

// Function to check if personalDetails has the required fields from the label
const hasPersonalDetails = (label, personalDetails)=>{
    // If there is not personal data, return false
    if (!personalDetails) {
        return false;
    }
    // Get label parameters
    const matches = label.match(/\{([^}]+)\}/g);
    // If there are no placeholders, we don't need to check anything
    if (!matches) {
        return true;
    }
    //check if personal details has the property
    const parameters = matches.map((match)=>{
        const property = match.replace(/[{}]/g, '');
        if (personalDetails[property]) {
            return true;
        }
        return false;
    });
    //all parameters must be exist in personal details
    return parameters.every((parameter)=>parameter
    );
};
const getPersonalizedGreeting = ({ getLabel , getFormattedLabel , personalDetails  })=>{
    const augmentedPersonalDetails = swcHelpers.objectSpread({}, personalDetails, (personalDetails === null || personalDetails === void 0 ? void 0 : personalDetails.firstName) ? {
        firstLetter: personalDetails === null || personalDetails === void 0 ? void 0 : personalDetails.firstName.substring(0, 1)
    } : {});
    const message = hasPersonalDetails(getLabel('account.menu.greeting.withPersonalDetails'), augmentedPersonalDetails) ? getFormattedLabel('account.menu.greeting.withPersonalDetails', {
        labelData: augmentedPersonalDetails
    }) : getLabel('account.menu.greeting.withoutPersonalDetails');
    return message;
};

export { getPersonalizedGreeting };
//# sourceMappingURL=get-personalized-greeting.js.map
